import { EditorProviderButtonSettings } from '../EditorProviderButtonSettings';
import { customizeCraftJsComponent } from '../../helpers';
import { EditorButton } from '../EditorButton';

export const EditorMicrosoftButton = customizeCraftJsComponent(EditorButton, {
	name: 'Microsoft Button',
	props: {
		children: '',
		startIcon: 'microsoft',
		shape: 'square',
		variant: 'outline',
		'data-descope-provider': 'microsoft',
		startIconColorText: false,
		formNoValidate: true,
		'data-type': 'social'
	},
	related: {
		settings: EditorProviderButtonSettings
	},
	custom: {
		subType: 'social'
	}
});
